/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificationDto { 
    id: number;
    recipientId: number;
    schoolId: number;
    type: NotificationDto.TypeEnum;
    title: string;
    body: string;
    entityType?: string | null;
    entityId?: number | null;
    isRead: boolean;
    readAt?: string | null;
    createdAt: string;
}
export namespace NotificationDto {
    export const TypeEnum = {
        LearnerTransferRequested: 'LEARNER_TRANSFER_REQUESTED',
        LearnerTransferApproved: 'LEARNER_TRANSFER_APPROVED',
        LearnerTransferRejected: 'LEARNER_TRANSFER_REJECTED',
        StaffDepartureRequested: 'STAFF_DEPARTURE_REQUESTED',
        StaffDepartureApproved: 'STAFF_DEPARTURE_APPROVED',
        StaffDepartureRejected: 'STAFF_DEPARTURE_REJECTED',
        StaffDismissed: 'STAFF_DISMISSED'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


